import { createAction } from '../util/';

export const setSearchTerm = createAction('SET_SEARCH_TERM');
export const setSilentSearchTerm = createAction('SET_SILENT_SEARCH_TERM');
export const setAddressSearchTerm = createAction('SET_ADDRESS_SEARCH_TERM');
export const setSortBy = createAction('SET_SORT_BY');
export const setScrollCache = createAction('SET_SCROLL_CACHE');
